export const US_STATES = [
    { abbreviation: 'AK', name: 'Alaska' },
    { abbreviation: 'AL', name: 'Alabama' },
    { abbreviation: 'AR', name: 'Arkansas' },
    { abbreviation: 'AS', name: 'American Samoa' },
    { abbreviation: 'AZ', name: 'Arizona' },
    { abbreviation: 'CA', name: 'California' },
    { abbreviation: 'CO', name: 'Colorado' },
    { abbreviation: 'CT', name: 'Connecticut' },
    { abbreviation: 'DC', name: 'District of Columbia' },
    { abbreviation: 'DE', name: 'Delaware' },
    { abbreviation: 'FL', name: 'Florida' },
    { abbreviation: 'GA', name: 'Georgia' },
    { abbreviation: 'GU', name: 'Guam' },
    { abbreviation: 'HI', name: 'Hawaii' },
    { abbreviation: 'IA', name: 'Iowa' },
    { abbreviation: 'ID', name: 'Idaho' },
    { abbreviation: 'IL', name: 'Illinois' },
    { abbreviation: 'IN', name: 'Indiana' },
    { abbreviation: 'KS', name: 'Kansas' },
    { abbreviation: 'KY', name: 'Kentucky' },
    { abbreviation: 'LA', name: 'Louisiana' },
    { abbreviation: 'MA', name: 'Massachusetts' },
    { abbreviation: 'MD', name: 'Maryland' },
    { abbreviation: 'ME', name: 'Maine' },
    { abbreviation: 'MI', name: 'Michigan' },
    { abbreviation: 'MN', name: 'Minnesota' },
    { abbreviation: 'MO', name: 'Missouri' },
    { abbreviation: 'MS', name: 'Mississippi' },
    { abbreviation: 'MT', name: 'Montana' },
    { abbreviation: 'NC', name: 'North Carolina' },
    { abbreviation: 'ND', name: 'North Dakota' },
    { abbreviation: 'NE', name: 'Nebraska' },
    { abbreviation: 'NH', name: 'New Hampshire' },
    { abbreviation: 'NJ', name: 'New Jersey' },
    { abbreviation: 'NM', name: 'New Mexico' },
    { abbreviation: 'NV', name: 'Nevada' },
    { abbreviation: 'NY', name: 'New York' },
    { abbreviation: 'OH', name: 'Ohio' },
    { abbreviation: 'OK', name: 'Oklahoma' },
    { abbreviation: 'OR', name: 'Oregon' },
    { abbreviation: 'PA', name: 'Pennsylvania' },
    { abbreviation: 'PR', name: 'Puerto Rico' },
    { abbreviation: 'RI', name: 'Rhode Island' },
    { abbreviation: 'SC', name: 'South Carolina' },
    { abbreviation: 'SD', name: 'South Dakota' },
    { abbreviation: 'TN', name: 'Tennessee' },
    { abbreviation: 'TX', name: 'Texas' },
    { abbreviation: 'UT', name: 'Utah' },
    { abbreviation: 'VA', name: 'Virginia' },
    { abbreviation: 'VI', name: 'Virgin Islands' },
    { abbreviation: 'VT', name: 'Vermont' },
    { abbreviation: 'WA', name: 'Washington' },
    { abbreviation: 'WI', name: 'Wisconsin' },
    { abbreviation: 'WV', name: 'West Virginia' },
    { abbreviation: 'WY', name: 'Wyoming' }
];


// WEBPACK FOOTER //
// ./src/Fuse/shared/usStates.js